<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IAl0dN/tc-custom/9781480446779.jpg?1703877195695" alt="This image is the cover for the book Dead Aim, The Lt. Hastings Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dead Aim, The Lt. Hastings Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A pair of murders leaves Hastings torn between following his orders and listening to his gut</b><br/>After nearly a decade as a San Francisco cop, Frank Hastings is becoming something of a stranger to kindness. He feels perfectly at home in the Draper household—a rundown Victorian not far from the streets on which he grew up—where a social worker has been beaten to death by a man hiding in the bushes. The crime looks like a mugging, but something in the husband’s manner tells Hastings there are secrets hidden in this shabby middle-class home.<br/>He’s closing in on the answers when a double homicide in posh Pacific Heights draws his attention away. Fearing bad publicity, his superiors tell him to drop everything and focus on this new killing, but Hastings can’t get his mind off the death of Susan Draper. As he divides his time between the two murders, Hastings finds that for a man at home with cruelty, kindness can be terrifying.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Collin  Wilcox
      </h2>
      
      <p class="authorDescription body article">Collin Wilcox (1924&ndash;1996) was an American author of mystery fiction. Born in Detroit, he set most of his work in San Francisco, beginning with 1967&rsquo;s <i>The Black Door</i>&mdash;a noir thriller starring a crime reporter with extrasensory perception. Under the pen name Carter Wick, he published several standalone mysteries including <i>The Faceless Man</i> (1975) and <i>Dark House, Dark Road</i> (1982), but he found his greatest success under his own name, with the celebrated Frank Hastings series.<BR>Hastings, a football player turned San Francisco homicide detective, made his debut in <i>The Lonely Hunter</i> (1969), and Wilcox continued to follow him for the rest of his career, publishing nearly two dozen novels in the series, which concludes with <i>Calculated Risk</i> (1995). Wilcox&rsquo;s other best-known series stars Alan Bernhardt, a theatrical director with a habit of getting involved in behind-the-scenes mysteries. Bernhardt appeared in four more books after his introduction in 1988&rsquo;s <i>Bernhardt&rsquo;s Edge</i>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?84628836